import { useEffect } from 'react';
import { mobilePageTitleStore } from '../mobilePageTitleStore';

/**
 * Names the entity of a deep page in the mobile top bar (design b4). `undefined` while it loads.
 * The name goes away when the page unmounts.
 */
export function useMobilePageTitle(title: string | undefined): void {
  useEffect(() => {
    mobilePageTitleStore.set(title);
    return () => mobilePageTitleStore.set(undefined);
  }, [title]);
}
